/* eslint-disable no-console */

import { register } from "register-service-worker";

//register(`${process.env.BASE_URL}firebase-messaging-sw.js`);
if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready(registeration) {
      console.log("App is being served from cache by a service worker.");
    },
    registered() {
      console.log("Service worker has been registered.");
      if (navigator.serviceWorker) {
        navigator.serviceWorker.addEventListener("message", (event) => {
          // event is a MessageEvent object

          console.log("event:", event);
          if (event.data?.type === "VERSION") {
            window.installedVersion = event.data.installedVersion;
            window.latestVersion = event.data.latestVersion;
          }
        });

        const requestVersion = () => {
          try {
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({
                type: "VERSION_REQUEST",
              });
            }
          } catch (e) {
            console.error(e);
          }
        };

        // Request version once the SW is active (handles first-load where
        // controller is null until the SW activates and claims the page)
        navigator.serviceWorker.ready.then(() => {
          requestVersion();
        });

        // Also re-request when a new SW takes control (e.g. after update)
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          requestVersion();
        });
      }
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; Refresh...");
      setTimeout(() => {
        window.location.reload(true);
      }, 2000);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
